package us.laantech.common.dto

import kotlinx.serialization.Serializable


@Serializable
data class PayoutInfoDTO(
    val createdAt: String,

    val amountCents: Long,

    val payoutType: PayoutType,

    val description: String? = null,
    val recipient: String? = null,
    val payoutMethod: PayoutMethod? = null,

    // For vendor payouts
    val invoiceNumber: String? = null,
    val bankName: String? = null,
    val checkNumber: String? = null,
    val checkDate: String? = null,

    // For winnings payouts
    val winningType: WinningType? = null,

    // Cupon info
    val cuponCode: String? = null,

    // Expense info
    val expenseTitle: String? = null,
    val storeName: Long? = null,

    // Cashback info
    val cashbackFeeCents: Long? = null,
) {
    init {
        // Validate based on payout type
    }
}

enum class PayoutType {
    VENDOR,
    WINNINGS,
    CUPON,
    EXPENSE,
    CASHBACK
}

enum class PayoutMethod {
    CASH,
    CHECK,
}

enum class WinningType {
    LOTTO,
    SCRATCH,
}